var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"btn-brand shadow-sm",attrs:{"variant":"light","pill":""},on:{"click":_vm.createTemplate}},[_vm._v(" "+_vm._s(_vm.$t("Create Template"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }